import { jsx } from 'react/jsx-runtime';
import { forwardRef, useRef } from 'react';
import { Combobox as Combobox$1 } from 'baseui/combobox';
import useMergedRef from '@react-hook/merged-ref';
import { mergeOverrides } from '../../../overrides.js';
import 'baseui';
import '../../../theme/olx-theme/base-theme.js';
import '../../../theme/olx-theme/theme.js';
import { useResolvedStyle, mergeStyles } from '../../../theme/utils.js';
import '../../../theme/types.js';
import { Input } from '../input/input.js';
import '../input/stateful-input.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getStyles = (styleProps, element) => {
  const { $theme, $isSelected } = styleProps;
  switch (element) {
    case "ListBox":
      return {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        backgroundColor: $theme.colors["background-global-secondary"],
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: $theme.radii[4],
        borderBottomRightRadius: $theme.radii[4],
        boxShadow: $theme.shadow[16]
      };
    case "Popover.Body":
      return {
        zIndex: $theme.zIndices.dropdown,
        boxShadow: "none",
        marginTop: 0
      };
    case "ListItem":
      return __spreadProps(__spreadValues({}, $theme.typography.p2), {
        color: $isSelected ? $theme.colors["text-global-inverse"] : "inherit",
        height: "initial",
        paddingTop: $theme.space[12],
        paddingBottom: $theme.space[12],
        paddingLeft: $theme.space[14],
        paddingRight: $theme.space[14]
      });
    default:
      return {};
  }
};
const ComboboxInner = (_a, ref) => {
  var _b = _a, { overrides, $style, startEnhancer, endEnhancer, placeholder, type } = _b, props = __objRest(_b, ["overrides", "$style", "startEnhancer", "endEnhancer", "placeholder", "type"]);
  const internalRef = useRef(null);
  const resolvedStyles = useResolvedStyle($style);
  const mergedRef = useMergedRef(ref, internalRef);
  return jsx(Combobox$1, __spreadValues({ inputRef: internalRef, overrides: mergeOverrides({
    Root: {
      style: (styleProps) => mergeStyles(getStyles(styleProps, "Root"), resolvedStyles)
    },
    Input: {
      component: Input,
      props: {
        ref: mergedRef,
        startEnhancer,
        endEnhancer,
        placeholder,
        type
      }
    },
    ListBox: {
      style: (styleProps) => getStyles(styleProps, "ListBox")
    },
    ListItem: {
      style: (styleProps) => getStyles(styleProps, "ListItem")
    },
    Popover: {
      props: {
        overrides: {
          Body: {
            style: (styleProps) => getStyles(styleProps, "Popover.Body")
          }
        }
      }
    }
  }, overrides) }, props));
};
const Combobox = forwardRef(ComboboxInner);

export { Combobox };
